module.exports = __webpack_public_path__ + "img/baocun.b3658bc4.png";